import { Directive, ElementRef, EventEmitter, HostListener, inject, Output } from '@angular/core';

@Directive({
  selector: '[cslClickOutside]',
  standalone: true,
})
export class ClickOutsideDirective {
  private readonly elementRef: ElementRef = inject(ElementRef);
  @Output() public cslClickOutside = new EventEmitter<HTMLElement>();

  @HostListener('document:mousedown', ['$event.target'])
  public clickListener(targetElement: EventTarget | null): void {
    if (!(targetElement instanceof HTMLElement)) {
      return;
    }
    const isInside = this.elementRef.nativeElement.contains(targetElement);
    if (!isInside) {
      this.cslClickOutside.emit(targetElement);
    }
  }
}
